import { React, useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import "./App.css";

import {
  Layout,
  Row,
  Col,
  Typography,
  FloatButton,
  Tooltip,
  Button,
  Select,
  Table,
  Input,
  Modal,
  Popover,
} from "antd/lib";
import {
  PlusOutlined,
  MinusCircleOutlined,
  AlertTwoTone,
  WarningTwoTone,
} from "@ant-design/icons";

import { saveCatalogTable } from "./services/azureBlobService";

import HeaderComponent from "./Components/HeaderComponent.js";

import { FileTextOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { getTemplateTypes, getLinkCatalogsList } from "./services/smasiAPIs.js";
import { ReactComponent as ClientLogo } from "./Assets/cm_logo.svg";
import { ReactComponent as CrdClientLogo } from "./Assets/crd_logo.svg";
const client =
  window.location.host.startsWith("vw.") ||
  window.location.href.includes("client=vw")
    ? "vw"
    : "cm";
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;
const containerName = "$web";

const TestCatalog = () => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [marketConfig, setMarketConfig] = useState(null);
  const [collectionsList, setCollectionsList] = useState([]);
  const [organizationId, setOrganizationId] = useState(null);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [selectedCollectionId, setSelectedCollectionId] = useState(null);
  const [blobName, setBlobName] = useState(null);
  const [templateTypesList, setTemplateTypesList] = useState([]);
  const [smasiInstance, setSmasiInstance] = useState(null);
  const [catalogData, setCatalogData] = useState([]);
  const [collectionLinkCatalogs, setCollectionLinkCatalogs] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const { authState, oktaAuth } = useOktaAuth();
  const [userEmail, setUserEmail] = useState(null);

  const allowedEmails = [
    "shreyas.shivakumar@credera.com",
    // "timothy.losper@credera.com",
  ];
  const hiddenColumns = [
    "TemplateVersion",
    "TestUrlReference",
    "CatalogSelection",
  ];

  const toggleEditing = () => {
    if (!isEditing) {
      Modal.confirm({
        icon: (
          <WarningTwoTone twoToneColor="red" style={{ fontSize: "3.33rem" }} />
        ),
        title: (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "1.75rem", fontWeight: "bold" }}>
              WARNING!
            </div>
            <div style={{ fontSize: "1.05rem" }}>
              Invalid changes will break test results.
            </div>
          </div>
        ),
        width: 500,
        // content: "Are you absolutely certain you want to proceed?",
        content: (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "0.95rem", fontWeight: "lighter" }}>
              Are you absolutely certain you want to proceed?
            </div>
          </div>
        ),
        style: { fontFamily: `${client}Regular`, fontSize: "2rem" },
        titleStyle: { fontSize: "2.75rem", fontWeight: "bold" },
        okText: "Yes",
        cancelText: "No",
        centered: true,
        onOk: () => setIsEditing(true),
        className: "catalog-alert",
      });
    } else {
      setIsEditing(false);
    }
  };

  useEffect(() => {
    document.title = `QA Auditor | Test Catalog`;

    const fetchData = async () => {
      try {
        const response =
          window.location.host.startsWith("pon.") ||
          window.location.href.includes("client=pon")
            ? await axios.get(
                `https://sdqareports.z6.web.core.windows.net/config/pon/marketConfig.json`,
              )
            : await axios.get(
                `https://sdqareports.z6.web.core.windows.net/config/${client}/marketConfig.json`,
              );
        setMarketConfig(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (authState?.isAuthenticated) {
      oktaAuth.getUser().then((user) => {
        setUserEmail(user.email);
      });
    }
  }, [authState, oktaAuth]);

  useEffect(() => {
    if (marketConfig !== null) {
      setCollectionsList(
        client === "cm"
          ? marketConfig["Nissan Motor Company"]
          : window.location.host.startsWith("pon.") ||
              window.location.href.includes("client=pon")
            ? marketConfig["PON Automotive"]
            : marketConfig["Volkswagen"],
      );
    }
  }, [marketConfig]);

  useEffect(() => {
    if (selectedCollection) {
      setBlobName(`catalog/${client}/${selectedCollection}/catalogConfig.json`);
      const fetchTableData = async () => {
        try {
          const response = await axios.get(
            `https://sdqareports.z6.web.core.windows.net/catalog/${client}/${selectedCollection}/catalogConfig.json?_=${new Date().getTime()}`,
            {
              responseType: "json",
            },
          );
          setCatalogData(JSON.parse(JSON.stringify(response.data)));
        } catch (error) {
          console.error("Error fetching data:", error);
          setCatalogData([]);
        }
      };
      fetchTableData();
    }
  }, [selectedCollection]);

  useEffect(() => {
    if (selectedCollectionId) {
      getLinkCatalogsList(smasiInstance, selectedCollectionId).then(
        (linkCatalogsList) => {
          linkCatalogsList.sort((a, b) =>
            a.groupName.localeCompare(b.groupName),
          );
          setCollectionLinkCatalogs(linkCatalogsList);
        },
      );
    }
  }, [selectedCollectionId]);

  useEffect(() => {
    if (organizationId) {
      getTemplateTypes(smasiInstance, organizationId).then(
        (templateTypesList) => {
          templateTypesList.sort((a, b) => a.name.localeCompare(b.name));
          setTemplateTypesList(templateTypesList);
        },
      );
    }
  }, [organizationId]);

  const togglePopover = () => {
    setPopoverVisible((prev) => !prev);
  };

  const handleInputChange = (value, record, key) => {
    const newData = catalogData.map((item) =>
      item.id.toString() === record.id.toString()
        ? { ...item, [key]: value }
        : item,
    );
    setCatalogData(newData);
  };

  const handleSelectedCollection = async (value, option) => {
    const collectionId = collectionsList.find(
      (collection) => collection.name === value,
    ).id;

    const orgId = collectionsList.find(
      (collection) => collection.name === value,
    ).organizationId;
    setOrganizationId(orgId);

    setSelectedCollection(value);
    setSelectedCollectionId(collectionId);
    setSmasiInstance(
      client === "cm" || value.toUpperCase() === "VWUSA" ? "ceres" : "mars",
    );
  };

  const handleAddRow = () => {
    setCatalogData([
      ...catalogData,
      {
        id: Date.now(),
        TemplateType: "",
        TemplateVersion: "1.0",
        TemplateSelector: "",
        CTASelector: "",
        TestUrlReference: "",
        CatalogSelection: [],
      },
    ]);
  };

  const handleDeleteRow = (id) => {
    setCatalogData(catalogData.filter((item) => item.id !== id));
  };

  const handleSaveCatalogTable = () => {
    saveCatalogTable(containerName, blobName, catalogData);
    toggleEditing();
  };

  const columns = [
    {
      title: (
        <Popover
          overlayInnerStyle={{
            fontFamily: `${client}Regular`,
          }}
          content={
            <p>
              Choose the template type that is pre-configured in SmaSi. This
              will allow the Auditor to select the correct Campaigns and assign
              the Selectors
            </p>
          }
          // title="Popover Title"
          trigger="click"
          placement="bottom"
          overlayStyle={{
            maxWidth: 250,
          }}
          overlayClassName="tutorialPopover"
          open={popoverVisible}
          onOpenChange={(visible) => setPopoverVisible(visible)}
        >
          <span>Template Type</span>
        </Popover>
      ),
      dataIndex: "TemplateType",
      key: "TemplateType",
      width: 220,
      render: (text, record) => (
        <Select
          value={text}
          onChange={(value) => handleInputChange(value, record, "TemplateType")}
          style={{ width: "100%" }}
          showSearch
          disabled={!isEditing}
        >
          {templateTypesList.map((option) => (
            <Option key={option.name} value={option.name}>
              {option.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Template Version",
      dataIndex: "TemplateVersion",
      key: "TemplateVersion",
      width: 180,
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(e.target.value, record, "TemplateVersion")
          }
          style={{ width: "100%" }}
          disabled={!isEditing}
        />
      ),
    },
    {
      title: (
        <Popover
          overlayInnerStyle={{
            fontFamily: `${client}Regular`,
          }}
          content={
            <p>
              The selector will allow the Auditor to locate the complete Visual
              for the Campaign and Action related to the vehicle model being
              tested.
            </p>
          }
          // title="Popover Title"
          trigger="click"
          placement="bottom"
          overlayStyle={{
            maxWidth: 300,
          }}
          overlayClassName="tutorialPopover"
          open={popoverVisible}
          onOpenChange={(visible) => setPopoverVisible(visible)}
        >
          <span>Template Selector</span>
        </Popover>
      ),
      dataIndex: "TemplateSelector",
      key: "TemplateSelector",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(e.target.value, record, "TemplateSelector")
          }
          style={{ width: "100%" }}
          disabled={!isEditing}
        />
      ),
    },
    {
      title: (
        <Popover
          overlayInnerStyle={{
            fontFamily: `${client}Regular`,
          }}
          content={
            <p>The selector to locate the CTA of the Action being tested.</p>
          }
          // title="Popover Title"
          trigger="click"
          placement="bottomLeft"
          overlayStyle={{
            maxWidth: 300,
          }}
          overlayClassName="tutorialPopover"
          open={popoverVisible}
          onOpenChange={(visible) => setPopoverVisible(visible)}
        >
          <span>CTA Selector</span>
        </Popover>
      ),
      dataIndex: "CTASelector",
      key: "CTASelector",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(e.target.value, record, "CTASelector")
          }
          style={{ width: "100%" }}
          disabled={!isEditing}
        />
      ),
    },
    {
      title: "Test URL Reference",
      dataIndex: "TestUrlReference",
      key: "TestUrlReference",
      render: (text, record) => (
        <Select
          value={text}
          onChange={(value) =>
            handleInputChange(value, record, "TestUrlReference")
          }
          style={{ width: "100%" }}
          disabled={!isEditing}
        >
          <Option value="LinkCatalog">Link Catalog</Option>
          <Option value="DisplayValidationUrl">Display Validation Url</Option>
        </Select>
      ),
    },
    {
      title: "Catalog Selection",
      dataIndex: "CatalogSelection",
      key: "CatalogSelection",
      render: (text, record) =>
        record.TestUrlReference === "LinkCatalog" ? (
          <Select
            mode="multiple"
            value={text}
            onChange={(value) =>
              handleInputChange(value, record, "CatalogSelection")
            }
            style={{ width: "100%" }}
            disabled={!isEditing}
          >
            {collectionLinkCatalogs.map((option) => (
              <Option key={option.groupName} value={option.groupName}>
                {option.groupName}
              </Option>
            ))}
          </Select>
        ) : (
          ""
        ),
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <Button
          icon={<MinusCircleOutlined />}
          type="text"
          danger
          onClick={() => handleDeleteRow(record.id)}
          disabled={!isEditing}
        />
      ),
    },
  ];

  return (
    <div>
      <Layout className="layout">
        <HeaderComponent collectionsList={collectionsList} />

        <Content
          style={{
            height: "100vh",
            background: "#F7FAF2",
            marginBottom: "2rem",
          }}
        >
          <div style={{ padding: "0 4vh" }}>
            <Row
              justify="space-between"
              align="middle"
              style={{ marginTop: "1.8rem" }}
            >
              <Col>
                <Text
                  strong
                  style={{
                    fontFamily: `${client}Compact`,
                    fontSize: client === "vw" ? "3.167rem" : "4.167rem",
                    lineHeight: "0.75",
                  }}
                >
                  TEST CATALOG
                </Text>
              </Col>
              <Col>
                {client === "cm" && (
                  <ClientLogo
                    style={{
                      marginTop: "12px",
                      height: "2rem",
                    }}
                  />
                )}
                {client === "vw" && (
                  <CrdClientLogo
                    style={{
                      marginTop: "12px",
                      height: "2.6rem",
                    }}
                  />
                )}
              </Col>
            </Row>

            <Row
              gutter={34}
              style={{ marginTop: "2rem", paddingBottom: "2rem" }}
            >
              <Col className="gutter-row" span={24}>
                <Popover
                  overlayInnerStyle={{
                    fontFamily: `${client}Regular`,
                  }}
                  content={
                    <p>Input the Collection that you would like to edit.</p>
                  }
                  // title="Popover Title"
                  trigger="click"
                  placement="top"
                  overlayStyle={{
                    maxWidth: 500,
                  }}
                  overlayClassName="tutorialPopover"
                  open={popoverVisible}
                  onOpenChange={(visible) => setPopoverVisible(visible)}
                />
                <Title
                  level={5}
                  style={{ fontFamily: `${client}Bold`, fontSize: "0.944rem" }}
                >
                  Collection
                </Title>
                <Row gutter={34} style={{ paddingBottom: "0rem" }}>
                  <Col className="gutter-row" span={4}>
                    <Select
                      key="client"
                      // defaultValue={}
                      showSearch
                      placeholder="Select..."
                      style={{ flex: 1, width: "11vw" }}
                      onChange={handleSelectedCollection}
                      value={selectedCollection || undefined}
                      dropdownStyle={{
                        fontFamily: `${client}Regular`,
                        fontSize: "0.944rem",
                      }}
                    >
                      {collectionsList.map((collection) => (
                        <Option key={collection.name} value={collection.name}>
                          {collection.name}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    {selectedCollection && (
                      <>
                        <div style={{ marginBottom: 16 }}>
                          <Popover
                            overlayInnerStyle={{
                              fontFamily: `${client}Regular`,
                            }}
                            content={
                              <p>
                                Edit Catalogs to change Catalog table. <br></br>
                                Discard Catalogs to discard your changes.
                              </p>
                            }
                            // title="Popover Title"
                            trigger="click"
                            placement="bottomLeft"
                            overlayStyle={{
                              maxWidth: 900,
                            }}
                            overlayClassName="tutorialPopover"
                            open={popoverVisible}
                            onOpenChange={(visible) =>
                              setPopoverVisible(visible)
                            }
                          />
                          <Button
                            type="primary"
                            onClick={toggleEditing}
                            style={{
                              fontFamily: `${client}Regular`,
                              marginBottom: 16,
                              width: "140px",
                              background: "#2045C0",
                              color: "#FFFFFF",
                            }}
                          >
                            {isEditing ? "Discard changes" : "Edit Catalogs"}
                          </Button>
                        </div>
                      </>
                    )}
                  </Col>
                  <Col className="gutter-row" span={3}>
                    {selectedCollection && (
                      <>
                        <div style={{ marginBottom: 16 }}>
                          <Popover
                            overlayInnerStyle={{
                              fontFamily: `${client}Regular`,
                            }}
                            content={
                              <p>
                                Save changes made in Catalog table. <br></br>
                                <b>WARNING:</b> Invalid changes may have
                                breaking effects. Please double check that you
                                save only valid configuration.
                              </p>
                            }
                            // title="Popover Title"
                            trigger="click"
                            placement="topLeft"
                            overlayStyle={{
                              maxWidth: 600,
                            }}
                            overlayClassName="tutorialPopover"
                            open={popoverVisible}
                            onOpenChange={(visible) =>
                              setPopoverVisible(visible)
                            }
                          />
                          <Button
                            type="primary"
                            onClick={handleSaveCatalogTable}
                            style={{
                              fontFamily: `${client}Regular`,
                              // marginTop: 16,
                              marginBottom: 16,
                              width: "140px",
                              background: isEditing ? "#2045C0" : "",
                              color: isEditing ? "#FFFFFF" : "",
                            }}
                            disabled={!isEditing}
                          >
                            Save changes
                          </Button>
                        </div>
                      </>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <div>
              {selectedCollection && (
                <>
                  <div style={{ marginBottom: 16 }}>
                    <Popover
                      overlayInnerStyle={{
                        fontFamily: `${client}Regular`,
                      }}
                      content={
                        <p>
                          Add new row to the catalog table. Used for configuring
                          new campaign/action that needs to be tested.
                        </p>
                      }
                      // title="Popover Title"
                      trigger="click"
                      placement="bottom"
                      overlayStyle={{
                        maxWidth: 900,
                      }}
                      overlayClassName="tutorialPopover"
                      open={popoverVisible}
                      onOpenChange={(visible) => setPopoverVisible(visible)}
                    />
                    <Button
                      type="primary"
                      onClick={handleAddRow}
                      icon={<PlusOutlined />}
                      style={{
                        fontFamily: `${client}Regular`,
                        marginBottom: 16,
                        width: "120px",
                        background: isEditing ? "#2045C0" : "",
                        color: isEditing ? "#FFFFFF" : "",
                      }}
                      disabled={!isEditing}
                    >
                      Add Row
                    </Button>
                  </div>

                  <Table
                    dataSource={catalogData}
                    columns={
                      allowedEmails.includes(userEmail)
                        ? columns
                        : columns.filter(
                            (col) => !hiddenColumns.includes(col.key),
                          )
                    }
                    rowKey="id"
                    pagination={false}
                    className="catalog-table"
                  />
                </>
              )}
            </div>
            <div style={{ paddingBottom: "2rem" }}></div>
          </div>
          <FloatButton
            icon={<FileTextOutlined />}
            description="HELP"
            shape="square"
            className="helpButton"
            onClick={togglePopover}
            style={{
              insetInlineEnd: 0,
              top: "80%",
              transform: "translateY(-50%)",
              maxHeight: "48px",
            }}
          />
        </Content>
      </Layout>
    </div>
  );
};
export default TestCatalog;
